import styled from 'styled-components/macro'
import { animated } from '@react-spring/web'

import { colors } from 'styled/theme.styled'

export const Root = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow:hidden;

  > .Inner {
    position: fixed;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-rows: auto 1fr auto;
    transition: all, 0.3s;
    filter: blur(${({ blur }) => (blur ? 8 : 0)}px);

    > * {
      position: relative;
    }
  }

  .Loader {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colors.darkBlue};
  }
`

export const Header = styled(animated.div)`
  /* position: absolute;
  left: 0;
  top: 0; */
  width: 100%;
  height: 110px;
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  /* outline: 1px solid tomato; */
`

export const Footer = styled(animated.div)`
  width: 100%;
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 40px;

  @media only screen and (max-height: 950px) {
    padding-bottom: 20px;
  }
`

export const PhotoGalleryAnimated = styled(animated.div)`
position:absolute !important;

`

